import React, { useMemo } from 'react';
import { ApprovalStatusHistory, getCreditApplicationTypeLabel } from '@dill/dill-shared';
import AppCreditApplicationStatus from '../CreditApplications/CreditApplicationStatus';
import moment from 'moment';
import { DillModal } from '../../../general/Dill/DillModal';
import { DillButton } from '../../../general/Dill/DillButton';
import { DillColumn, DillTable } from '../../../general/Dill/DillTable';

const CreditAppHistoryModal = ({
  open,
  handleClose,
  approvalStatusHistory,
  onViewDetails,
}: {
  open: boolean;
  handleClose: () => void;
  approvalStatusHistory: ApprovalStatusHistory[];
  onViewDetails: (approvalStatusHistory: ApprovalStatusHistory) => void;
}) => {
  const columns = useMemo<DillColumn<ApprovalStatusHistory>[]>(
    () => [
      {
        key: 'status',
        label: 'Status',
        width: 140,
        sortable: false,
        render: (_, row) => (
          <div className="flex flex-col gap-1">
            <AppCreditApplicationStatus status={row.status} wrapperClassName="w-fit" />
            {row.comment && (
              <DillButton
                label="View Details"
                variant="secondary"
                onClick={() => onViewDetails(row)}
                className="flex justify-center"
              />
            )}
          </div>
        ),
      },
      {
        key: 'date',
        label: 'Date',
        width: 140,
        sortable: false,
        render: (_, row) => (
          <p className="capitalize w-full text-xs">{moment(row.date).format('MM/DD/YYYY LT')}</p>
        ),
      },
      {
        key: 'applicationType',
        label: 'Application Type',
        width: 140,
        sortable: false,
        render: (_, row) => (
          <p className="capitalize w-full text-xs">
            {getCreditApplicationTypeLabel(row.applicationType, { long: true })}
          </p>
        ),
      },
      {
        key: 'action',
        label: 'Action',
        width: 120,
        sortable: false,
        render: (_, row) => <p className="capitalize w-full text-xs">{row.action}</p>,
      },
      {
        key: 'actionBy',
        label: 'Action By',
        width: 140,
        sortable: false,
        render: (_, row) => <p className="w-full text-xs">{row.actionBy}</p>,
      },
      {
        key: 'notes',
        label: 'Notes',
        width: 200,
        sortable: false,
        render: (_, row) => <p className="w-full text-xs">{row.notes}</p>,
      },
    ],
    [onViewDetails]
  );

  return (
    <DillModal
      open={open}
      onClose={handleClose}
      title="Application History"
      maxWidth="80vw"
      footer={
        <div className="flex justify-end">
          <DillButton label="Close" variant="secondary" onClick={handleClose} />
        </div>
      }>
      <DillTable
        columns={columns}
        data={approvalStatusHistory}
        sortable
        pagination={false}
        emptyMessage="No history available."
        striped={false}
        rowHeight={74}
        resizable
        maxHeight="calc(100vh - 320px)"
        showCount={false}
      />
    </DillModal>
  );
};

export default CreditAppHistoryModal;
